import type { ReactNode } from "react";

/**
 * Visual grouping for the Dashboard. Each section gets a titled bordered
 * card with consistent padding so panels read as a logical cluster
 * (e.g. "Market Intelligence", "Leads", "Operations") rather than a
 * loose grid of coloured boxes.
 */
export function DashboardSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <section className="rounded-xl border bg-gray-50/50 p-3 lg:p-4">
      <div className="mb-2 flex items-baseline justify-between gap-3 px-1">
        <h2 className="text-sm font-semibold tracking-wide text-gray-700 uppercase">
          {title}
        </h2>
        {description && (
          <p className="text-[11px] text-gray-500">{description}</p>
        )}
      </div>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
